<script>
import compInterObserver from '@shared/utils/comp_inter_observer'; // 监听组件进出视图的单例
import pageScroll from '@shared/utils/page_scroll';// 页面滚动的单例
import _get from 'lodash/get';
import { isBrick, getComponentModule } from '@shared/const.js';


export default {
  name: 'dynamic-comp',
  props: {
    xSlot: {
      type: Object,
    },
    isLast: {
      type: Boolean,
    },
    comp: {
      type: Object,
    },
  },
  // comp-list注入pageInfo
  inject: ['navInfoStore', 'pageInfo', 'pageConfig'],
  updated() {
    // 将组件的DOM添加到监听组件进出视图和页面滚动的单例上
    const el = this.$el;
    if (el) {
      compInterObserver.addComp(el);
      pageScroll.addComp(el);
    }
  },
  mounted() {
    try {
      this.$Logger && this.$Logger.sendLogicInfoIdle('component', 'Ares渲染楼层', {
        pageInfo: JSON.stringify(this.pageInfo),
        comp: JSON.stringify(this.comp),
      });
    } catch (error) {

    }
  },
  methods: {
    resolveStyle() {
      const { comp } = this;
      if (isBrick(comp)) {
        return comp.formatStyle;
      }
      return {
        position: 'relative',
        'box-sizing': 'border-box',
        ...comp.formatStyle,
      };
    },
    renderPlaceholder() {
      if (process.env.isEdit) {
        const { isLast, comp } = this;
        const { compProps, name: compName, report = {}, desc, compId } = comp;
        const options = {
          attrs: {
            'data-compId': compId,

          },
          class: 'comp-placeholder',
        };
        return <div  {...options} v-loading="true"></div>;
      }
      return null;
    },
  },
  render() {
    const { isLast, comp } = this;
    const { compProps, name: compName, report = {}, desc, compId } = comp;

    const formatStyle = this.resolveStyle();

    const options = {
      props: {
        /**
         * 对应yaml props
         */
        compProps,
        report,
        desc,
        pageInfo: this.pageInfo,
        isLast,
        formatStyle,
        pageConfig: this.pageConfig,
      },
      attrs: {
        'data-compId': compId,
        id: compId,
        spm: (comp.report && comp.report.spm) || '',
        pageid: this.pageInfo.PageID || '',
        children: comp.children,
      },
      class: comp.class,
    };

    const children = this.$scopedSlots.children ? this.$scopedSlots.children() : null;


    // c端
    // 渲染自定义组件
    // 自定义组件在ares-view插槽中
    if (compName === 'custom-view' && !process.env.isEdit) {
      const customViewName = compProps.name;
      const $scopedSlots = this.xSlot;
      if (customViewName && $scopedSlots && $scopedSlots[customViewName]) {
        return $scopedSlots[customViewName](options.props.compProps);
      }
    }

    const C = getComponentModule(compName);
    if (!C) {
      return this.renderPlaceholder();
    }
    if (isBrick({ name: compName })) {
      /**
       * 积木组件
       */
      return <C {...options}></C>;
    }

    return <C {...options}>{children}</C>;
  },
};
</script>

<style scoped lang="scss">
.comp-placeholder{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  background: #fafafa;
}
</style>
